import React, { useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import logo from '../assets/HeaderPhotos/hdplogo.png';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <Navbar expand="lg" className="custom-navbar py-3" fixed="top">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img src={logo} height="60" alt="HDPMG Logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link 
              as={Link} to="/" 
              className={`nav-link-custom ${location.pathname === '/' ? 'active' : ''}`}
            >
              Home
            </Nav.Link>
            
            <Nav.Link 
              as={Link} to="/about-us" 
              className={`nav-link-custom ${location.pathname === '/about-us' ? 'active' : ''}`}
            >
              About Us
            </Nav.Link>
            
            <div 
              className="nav-item-custom"
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
            >
              <span 
                className={`nav-link-custom ${['/arizona-models', '/florida-models', '/texas-models'].includes(location.pathname) ? 'active' : ''}`}
                style={{ cursor: 'default', display: 'inline-block' }}
              >
                Our Projects
              </span>
              
              <div className={`custom-dropdown ${showDropdown ? 'show' : ''}`}>
                <Link 
                  to="/arizona-models" 
                  className="custom-dropdown-item"
                  onClick={() => setShowDropdown(false)}
                >
                  Arizona Models
                </Link>
                <Link 
                  to="/florida-models" 
                  className="custom-dropdown-item"
                  onClick={() => setShowDropdown(false)}
                >
                  Florida Models
                </Link>
                <Link 
                  to="/texas-models" 
                  className="custom-dropdown-item"
                  onClick={() => setShowDropdown(false)}
                >
                  Texas Models
                </Link>
              </div>
            </div>
            
            <Nav.Link 
              as={Link} to="/contact-us" 
              className={`nav-link-custom ${location.pathname === '/contact-us' ? 'active' : ''}`}
            >
              Contact Us
            </Nav.Link>

          </Nav>

          <Nav>
            <a 
              href="https://www.apartments.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="tenant-login-btn"
            >
              Tenants Login
            </a>
          </Nav>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;